/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LanguageModel } from '../../models/language-model';

export interface SearchClientIdLanguageGet$Plain$Params {
  clientId: string;
}

export function searchClientIdLanguageGet$Plain(http: HttpClient, rootUrl: string, params: SearchClientIdLanguageGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<LanguageModel>>> {
  const rb = new RequestBuilder(rootUrl, searchClientIdLanguageGet$Plain.PATH, 'get');
  if (params) {
    rb.path('clientId', params.clientId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<LanguageModel>>;
    })
  );
}

searchClientIdLanguageGet$Plain.PATH = '/Search/{clientId}/Language';
